<template>
    <div>
        
        <span class="stats--title mb-2 text-secondary fw-bold">{{ title }}
            <b-button 
                :id="'html-tooltip-button-title-' + circle_bg_color" 
                variant="link" 
                class="p-0" 
                v-b-tooltip.hover >
                <i 
                    class="fal fa-info-circle" 
                    style="color:grey"></i>
            </b-button>
            
            <b-tooltip 
                :target="'html-tooltip-button-title-' + circle_bg_color" 
                triggers="hover" 
                custom-class="left-aligned-tooltip"
                html>
                <h5>{{ tooltipText }}</h5>
                {{ tooltipBody }}
            </b-tooltip>
        </span>

        <hr>
        <div class="row">
            <div class="col-8">
                <div class="highlight--stats">
                    <div class="value--unit">
                        <span class="stats--value">
                            {{ title === 'Total QR' && typeof value !== 'object' ? numberWithCommas(value) + ' QR' : typeof value !== 'object' ? numberWithCommas(value) : 'Loading....' }}
                        </span>
                        <!-- <span class="stats--unit col-md-0 col-sm-0 col-xs-0">{{ unit }}</span> -->
                    </div>
                    <div class="text-left">
                        <template v-if="tooltipData">
                            <b-button  id="html-tooltip-button"  variant="link" class="p-0 " v-b-tooltip.hover >
                                <h5>
                                    <span style="font-weight: normal;">
                                        View Detail
                                    </span>
                                </h5>
                            </b-button>
                            <b-tooltip 
                                target="html-tooltip-button" 
                                triggers="hover" 
                                custom-class="left-aligned-tooltip"
                                html>
                                <br>
                                <!-- <b>{{ formatNumberWithCommas(tooltipData.total_product) }}</b> Product <br><br> -->
                                <b>{{ formatNumberWithCommas(tooltipData.total_unmaped) }}</b> Inactive <br><br>
                                <b>{{ formatNumberWithCommas(tooltipData.total_mapped) }}</b> Active <br><br>
                            </b-tooltip>
                        </template>
                        <template v-else-if="routeToPage">
                            <h5 style="color: #348fe2; cursor: pointer;">
                                <span style="font-weight: normal;" @click="$router.push({ name: routeToPage, query: pageQuery })">View Location</span>
                            </h5>
                        </template>
                        <template v-else>
                            <h5 style="color:white">-</h5>
                        </template>
                    </div> 
                </div>
            </div>
            <div class="col-4 stats--icon ">
                <div class="circle" :style="{'background-color' : circle_bg_color ? circle_bg_color : '#fff' , 'color' : circle_text_color ? circle_text_color : '#000'}">
                    <i class="far fa-2x" :class="icon"></i>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { add } from '@amcharts/amcharts4/.internal/core/utils/Array';

    export default {
        data () {
            return {
                mobile: this.isMobile(),
            }
        },
        props : [
            'title',
            'description',
            'value',
            'unit',
            'icon',
            'circle_bg_color',
            'circle_text_color',
            'tooltipText',
            'tooltipData',
            'routeToPage',
            'pageQuery',
            'tooltipBody'
        ],
        mounted () {

        },
        methods : {

            formatNumberWithCommas(number) {
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            }
            
        }
    }
</script>

<style>
    .left-aligned-tooltip .tooltip-inner {
  text-align: left;
  font-size: 12px;
  padding: 5px 10px; /* Adjust the padding value as needed */

}
</style>

<style scoped>
    .highlight--stats {
        background-color: white;
        border-radius: 8px;
        /* box-shadow: 0px 3px 10px #0000000F; */
        padding: 15px 0px;

        display: flex;
        flex-direction: column;
        /* align-items: center; */
        justify-content: center;
    }

    .value--unit {
        display: flex;
        flex-direction: row;
        /* justify-content: center; */
        justify-content: flex-start;
        align-items: flex-end;
    }
    
    .stats--title {
        font-size: 13px;
        font-weight: bold;
        color: #383838;
    }

    .stats--value {
        font-size: 25px;
        font-weight: bold;
        color: #383838;
    }

    .stats--unit {
        font-size: 14px;
        font-weight: 500;
        color: #D1D1D1;
        padding: 0 0 10px 10px;
    }

    .stats--icon {
        display:flex; 
        align-items:center; 
        justify-content:center;
        text-align: center;
    }

    .circle {
    /* Circle size */
        width: 57px;
        height: 57px;
        
        /* Make it a circle */
        border-radius: 50%;
        
        /* Circle color */
         /* Red color for demonstration */
        
        /* Centering the circle inside the container */
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        align-items: center;
    }
</style>
